import React from 'react';
import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import Card from './Card';
import './css/CardList.css'

export default function CardList({cards}) {
    
    
    return (
            
           cards.map(card => {
            return <Card key = {card.id} 
            id = {card.id}
            title = {card.name}
            imageUrl = {card.imageUrl}
            body = {card.breed}
            sex = {card.sex}
            size = {card.size}
            age = {card.age}
            shelterId = {card.shelterId}
            card={card} 
            />
        })        
        
    )
}
